import { firebaseStateReducer } from 'react-redux-firebase'

export default firebaseStateReducer;



// WEBPACK FOOTER //
// ./src/reducers/firebase.js